import { Localizer } from '../utils/localize.js';

export const skSk = {
    code: 'sk-sk',
    name: 'Slovak',
    dir: 'ltr',

    welcome: 'Vitajte',
    'wj.file.upload.button': 'Vybrať súbor',
    'wj.file.upload.uploaded': 'Nahraných: ',
    'wj.file.upload.from': 'z',
    'wj.file.upload.error.invalid.type': 'Tento formát súboru nie je podporovaný. Povolené formáty: {acceptedTypes}.',
    'wj.file.upload.error.file.too.large': 'Súbor je príliš veľký. Maximálna veľkosť je {maxFileSize} MB.',
    'wj.file.upload.error.max.files': 'Môžete nahrať najviac {maxFiles} súborov.',
    'wj.file.upload.error.generic': 'Súbor sa nepodarilo nahrať.',
    'wj.stepper.button.next': 'Ďalej',
    'wj.stepper.button.finish': 'Dokončiť',
    'wj.stepper.button.previous': 'Späť',
    'wj.stepper.step': 'Krok',
    'wj.pagination.of': 'z',
    'wj.pagination.itemsPerPage': 'Záznamy na stránke',
    'wj.pagination.first': 'Prvá stránka',
    'wj.pagination.prev': 'Predchádzajúca',
    'wj.pagination.next': 'Ďalšia',
    'wj.pagination.last': 'Posledná stránka',
    'wj.select.empty': 'Žiadne dáta',
};

Localizer.registerTranslation(skSk);
